import React from 'react';
import Button from '../../../GbsUI/UI/Button';
import ArrowRightIcon from '../../../GbsUI/UI/icons/ArrowRight';
import SignupLayout from '../components/Layout';

const SignupSuccess = () => {
  return (
    <div>
      <SignupLayout
        footer={
          <>
            <Button
              size={'xl'}
              icon={ArrowRightIcon}
              iconProps={{ size: 21 }}
              iconPosition={'right'}
              onClick={() => {
                window.location.href = '/home';
              }}
            >
              RETURN TO GOBUYSIDE
            </Button>
          </>
        }
      >
        <div className={'signup__success'}>
          <svg width="50" height="50" fill="none">
            <path
              fill="#00A889"
              fillRule="evenodd"
              d="M1.04 25a23.96 23.96 0 1 1 47.92 0 23.96 23.96 0 0 1-47.92 0Zm37.37-6.49-17.39 17.4-9.43-9.44 2.95-2.94L21.02 30l14.45-14.44 2.94 2.94Z"
              clipRule="evenodd"
            />
          </svg>
          <h1>Thanks for Completing Your Application!</h1>
          <p>
            Our team will review your application shortly. Most applications are approved within 1–2 business days. Once approved, you’ll gain full access to the platform.
          </p>
        </div>
      </SignupLayout>
    </div>
  );
};

export default SignupSuccess;
